var map = {
	"./aco.jpg": 996,
	"./aluminio.jpg": 92,
	"./bronze.jpg": 990,
	"./calculadora/calc-bucha.jpg": 615,
	"./calculadora/calc-cantoneira.jpg": 442,
	"./calculadora/calc-chapa.jpg": 574,
	"./calculadora/calc-quadrado.jpg": 183,
	"./calculadora/calc-redondo.jpg": 520,
	"./calculadora/calc-retangulo.jpg": 662,
	"./calculadora/calc-sextavado.jpg": 652,
	"./calculadora/calc-tubo-quadrado.jpg": 624,
	"./calculadora/calc-tubo-redondo.jpg": 767,
	"./calculadora/calc-tubo-retangulo.jpg": 113,
	"./calculadora/calc-viga-u.jpg": 86,
	"./cobre.jpg": 903,
	"./ff.jpg": 709,
	"./galpao-butzke.jpg": 65,
	"./inox.jpg": 830,
	"./latao.jpg": 121,
	"./logotipo_flavia-j.-rausis-berthold-2_page-0001.jpg": 425,
	"./nylon.jpg": 803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 477;